export default function yupInquiryNameValidate(y) {
  y.addMethod(y.string, "inquiryName", function () {
    return this.test("inquiryName", `記号やスペース以外の文字を含むお名前を入力してください。`, function (value) {
      // 全角数字、全角英小文字、全角英大文字、長音、ひらがな、カタカナ、漢字、サロゲートペア、サロゲートペア、漢字、サロゲートペア、々
      // 上記を含むか
      const regexp = /[(０-９|ａ-ｚ|Ａ-Ｚ|ー|\u3041-\u3096|\u30A1-\u30FA|\u3400-\u9FFF|\uD840-\uD87F|\uDC00-\uDFFF|\uF900-\uFAFF|\u{20000}-\u{37FFF}|々)]/u;
      return regexp.test(value);
    });
  });
}